/** Stable command identities shared by Visit metadata, dialog preparation and queued row execution. */
export enum VisitBulkActionId {
    CreateJobs = 'visit.createJobs',
    Reschedule = 'visit.reschedule',
    Skip = 'visit.skip',
    Approve = 'visit.approve',
    /** Withdraws the selected work (whole Visits, or chosen task rows) from the approvals that own it. */
    WithdrawApproval = 'visit.withdrawApproval',
}
